export default __webpack_public_path__ + "static/media/javascript.7bb08cdb.svg";